import { Sentry, SentryTeam } from 'lib-shared-sentry';
import { ReactNode } from 'react';

type KnowledgeErrorBoundaryProps = {
  children: ReactNode;
} & Pick<Sentry.ErrorBoundaryProps, 'fallback'>;
/**
 * Used to ensure that Knowledge-related features get tagged correctly to the
 * knowledge team in agent-interface's Sentry project
 */
export function KnowledgeErrorBoundary({
  children,
  fallback,
}: KnowledgeErrorBoundaryProps): JSX.Element {
  function onError(error: unknown) {
    Sentry.captureException(error, {
      tags: {
        team: SentryTeam.Knowledge,
      },
    });
  }

  return (
    <Sentry.ErrorBoundary fallback={fallback} onError={onError}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
